import { FormValidationComponent } from 'core/validation/form/form-validation.component'

export class InputValidationObserver {

  constructor(formElement, constraints) {
    this.validator = new FormValidationComponent(formElement, constraints)
  }

  next(target) {
    const errors = this.validator.validateInputs()
    this.validator.showErrorForInput(target, (errors) ? errors[target.name] : undefined)
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/validation/input/input-validation.observer.js